import { DocumentNode } from 'graphql'
import {
  GET_APPLICATIONS,
  GET_DOCUMENT_TYPES,
  GET_INQUIRIES,
  GET_ELEMENTS,
  GET_ELEMENT_MATERIALS,
  GET_ELEMENT_MATERIAL_CONF,
  GET_ELEMENT_ORIENTATIONS,
  GET_ELEMENT_TYPES,
  GET_FITTING_TYPES,
  GET_FIXING_CATEGORIES,
  GET_INDUSTRY_CATEGORIES,
  GET_PRODUCTS,
  GET_PRODUCT_CATEGORIES,
  GET_PRODUCT_INSTALLATION_TYPES,
  GET_PRODUCT_INSTRUCTION_LIST,
  GET_PRODUCT_MANUFACTURERS,
  GET_PRODUCT_TYPES,
  GET_REPORTS,
  GET_REPORT_FACILITIES,
  GET_REPORT_PUBLISHINGS,
  GET_REPORT_STATUSES,
  GET_REPORT_STANDARD_LIST,
  GET_REPORT_TYPES,
  GET_SEALING_METHODS,
  GET_SERVICES,
  GET_SERVICE_CATEGORIES,
  GET_SERVICE_SUB_CATEGORIES,
  GET_SERVICE_CONFIGURATIONS,
  GET_SERVICE_MANUFACTURERS,
  GET_SERVICE_MATERIALS,
  GET_SERVICE_TYPES,
  GET_SERVICE_STANDARDS,
  GET_COMPONENT_PRODUCTS,
  GET_SYSTEM,
  GET_UNITS,
  GET_DOCUMENT_VERSIONS,
  GET_DIMENSION_TYPES,
  GET_FRL_STANDARDS,
  GET_FAQS,
  GET_HOMEPAGE_TILES,
  GET_SNAP_USERS,
  MUTATION_CREATE_APPLICATION,
  MUTATION_CREATE_DOCUMENT_TYPE,
  MUTATION_CREATE_ELEMENT,
  MUTATION_CREATE_ELEMENT_MATERIAL,
  MUTATION_CREATE_ELEMENT_MATERIAL_CONF,
  MUTATION_CREATE_ELEMENT_ORIENTATION,
  MUTATION_CREATE_ELEMENT_TYPE,
  MUTATION_CREATE_FITTING_TYPE,
  MUTATION_CREATE_FIXING_CATEGORIES,
  MUTATION_CREATE_INDUSTRY_CATEGORY,
  MUTATION_CREATE_PRODUCT,
  MUTATION_CREATE_PRODUCT_CATEGORY,
  MUTATION_CREATE_PRODUCT_INSTALLATION_TYPE,
  MUTATION_CREATE_PRODUCT_INSTRUCTION_LIST,
  MUTATION_CREATE_PRODUCT_MANUFACTURER,
  MUTATION_CREATE_PRODUCT_TYPE,
  MUTATION_CREATE_PRODUCT_MATCHING_LIST,
  MUTATION_CREATE_REPORT,
  MUTATION_CREATE_REPORT_FACILITY,
  MUTATION_CREATE_REPORT_PUBLISHING,
  MUTATION_CREATE_REPORT_STATUS,
  MUTATION_CREATE_REPORT_STANDARD_LIST,
  MUTATION_CREATE_REPORT_TYPE,
  MUTATION_CREATE_SEALING_METHODS,
  MUTATION_CREATE_SERVICE,
  MUTATION_CREATE_SERVICE_CATEGORY,
  MUTATION_CREATE_SERVICE_SUB_CATEGORY,
  MUTATION_CREATE_SERVICE_CONFIGURATION,
  MUTATION_CREATE_SERVICE_MANUFACTURERS,
  MUTATION_CREATE_SERVICE_MATERIALS,
  MUTATION_CREATE_SERVICE_TYPES,
  MUTATION_CREATE_UNITS,
  MUTATION_CREATE_DOCUMENT_VERSION,
  MUTATION_CREATE_DIMENSION_TYPE,
  MUTATION_CREATE_FRL_STANDARD,
  MUTATION_CREATE_FAQ,
  MUTATION_DELETE_APPLICATION,
  MUTATION_DELETE_DOCUMENT_TYPE,
  MUTATION_DELETE_ELEMENT,
  MUTATION_DELETE_ELEMENT_MATERIAL,
  MUTATION_DELETE_ELEMENT_MATERIAL_CONF,
  MUTATION_DELETE_ELEMENT_ORIENTATION,
  MUTATION_DELETE_ELEMENT_TYPE,
  MUTATION_DELETE_FITTING_TYPE,
  MUTATION_DELETE_FIXING_CATEGORIES,
  MUTATION_DELETE_INDUSTRY_CATEGORY,
  MUTATION_DELETE_PRODUCT,
  MUTATION_DELETE_PRODUCT_CATEGORY,
  MUTATION_DELETE_PRODUCT_INSTALLATION_TYPE,
  MUTATION_DELETE_PRODUCT_MANUFACTURER,
  MUTATION_DELETE_PRODUCT_PRODUCT_INSTRUCTION_LIST,
  MUTATION_DELETE_PRODUCT_TYPE,
  MUTATION_DELETE_PRODUCT_MATCHING_LIST,
  MUTATION_DELETE_REPORT,
  MUTATION_DELETE_REPORT_FACILITY,
  MUTATION_DELETE_REPORT_PUBLISHING,
  MUTATION_DELETE_REPORT_STATUS,
  MUTATION_DELETE_REPORT_STANDARD_LIST,
  MUTATION_DELETE_REPORT_TYPE,
  MUTATION_DELETE_SEALING_METHODS,
  MUTATION_DELETE_SERVICE,
  MUTATION_DELETE_SERVICE_CATEGORY,
  MUTATION_DELETE_SERVICE_SUB_CATEGORY,
  MUTATION_DELETE_SERVICE_CONFIGURATION,
  MUTATION_DELETE_SERVICE_MANUFACTURERS,
  MUTATION_DELETE_SERVICE_MATERIALS,
  MUTATION_DELETE_SERVICE_TYPES,
  MUTATION_DELETE_UNITS,
  MUTATION_DELETE_DOCUMENT_VERSION,
  MUTATION_DELETE_DIMENSION_TYPE,
  MUTATION_DELETE_FRL_STANDARD,
  MUTATION_DELETE_FAQ,
  MUTATION_UPDATE_APPLICATION,
  MUTATION_UPDATE_DOCUMENT_TYPE,
  MUTATION_UPDATE_ELEMENT,
  MUTATION_UPDATE_ELEMENT_MATERIAL,
  MUTATION_UPDATE_ELEMENT_MATERIAL_CONF,
  MUTATION_UPDATE_ELEMENT_ORIENTATION,
  MUTATION_UPDATE_ELEMENT_TYPE,
  MUTATION_UPDATE_FITTING_TYPE,
  MUTATION_UPDATE_FIXING_CATEGORIES,
  MUTATION_UPDATE_INDUSTRY_CATEGORY,
  MUTATION_UPDATE_PRODUCT,
  MUTATION_UPDATE_PRODUCT_CATEGORY,
  MUTATION_UPDATE_PRODUCT_INSTALLATION_TYPE,
  MUTATION_UPDATE_PRODUCT_INSTRUCTION_LIST,
  MUTATION_UPDATE_PRODUCT_MANUFACTURER,
  MUTATION_UPDATE_PRODUCT_TYPE,
  MUTATION_UPDATE_PRODUCT_MATCHING_LIST,
  MUTATION_UPDATE_REPORT,
  MUTATION_UPDATE_REPORT_FACILITY,
  MUTATION_UPDATE_REPORT_PUBLISHING,
  MUTATION_UPDATE_REPORT_STATUS,
  MUTATION_UPDATE_REPORT_STANDARD_LIST,
  MUTATION_UPDATE_REPORT_TYPE,
  MUTATION_UPDATE_SEALING_METHODS,
  MUTATION_UPDATE_SERVICE,
  MUTATION_UPDATE_SERVICE_CATEGORY,
  MUTATION_UPDATE_SERVICE_SUB_CATEGORY,
  MUTATION_UPDATE_SERVICE_CONFIGURATION,
  MUTATION_UPDATE_SERVICE_MANUFACTURERS,
  MUTATION_UPDATE_SERVICE_MATERIALS,
  MUTATION_UPDATE_SERVICE_TYPES,
  MUTATION_UPDATE_SERVICE_STANDARD,
  MUTATION_UPDATE_UNITS,
  MUTATION_UPDATE_DOCUMENT_VERSION,
  MUTATION_UPDATE_DIMENSION_TYPE,
  MUTATION_UPDATE_FRL_STANDARD,
  MUTATION_UPDATE_FAQ,
  MUTATION_CREATE_COMPONENT_PRODUCT,
  MUTATION_UPDATE_COMPONENT_PRODUCT,
  MUTATION_DELETE_COMPONENT_PRODUCT,
  MUTATION_DELETE_SYSTEM,
  MUTATION_CREATE_SYSTEM,
  MUTATION_UPDATE_SYSTEM,
  MUTATION_CREATE_PRODUCT_SUB_CATEGORY,
  MUTATION_UPDATE_PRODUCT_SUB_CATEGORY,
  MUTATION_DELETE_PRODUCT_SUB_CATEGORY,
  GET_PRODUCT_SUB_CATEGORIES,
  MUTATION_CREATE_HOMEPAGE_TILE,
  MUTATION_UPDATE_HOMEPAGE_TILE,
  MUTATION_DELETE_HOMEPAGE_TILE,
  GET_PRODUCT_MATCHING_LIST,
  GET_FIXING_TESTED,
  MUTATION_CREATE_FIXING_TESTED,
  MUTATION_UPDATE_FIXING_TESTED,
  MUTATION_DELETE_FIXING_TESTED,
  GET_FMP_PROJECTS,
  MUTATION_CREATE_PRODUCT_ACCESSORY_MATCH,
  MUTATION_UPDATE_PRODUCT_ACCESSORY_MATCH,
  GET_PRODUCT_ACCESSORY_MATCH,
  MUTATION_DELETE_PRODUCT_ACCESSORY_MATCH,
  MUTATION_CREATE_PRODUCT_BRAND,
  MUTATION_UPDATE_PRODUCT_BRAND,
  GET_PRODUCT_BRANDS,
  MUTATION_DELETE_PRODUCT_BRAND,
  MUTATION_CREATE_SERVICE_BRANDS,
  MUTATION_UPDATE_SERVICE_BRANDS,
  GET_SERVICE_BRANDS,
  MUTATION_DELETE_SERVICE_BRANDS,
  GET_PRODUCT_INDUSTRIES,
  MUTATION_CREATE_PRODUCT_INDUSTRY,
  MUTATION_UPDATE_PRODUCT_INDUSTRY,
  MUTATION_DELETE_PRODUCT_INDUSTRY,
  GET_SERVICE_STANDARD_MATCH,
  MUTATION_CREATE_SERVICE_STANDARD_MATCH,
  MUTATION_UPDATE_SERVICE_STANDARD_MATCH,
  MUTATION_DELETE_SERVICE_STANDARD_MATCH,
  GET_SERVICE_ADD_TYPES,
  MUTATION_CREATE_SERVICE_ADD_TYPE,
  MUTATION_UPDATE_SERVICE_ADD_TYPE,
  MUTATION_DELETE_SERVICE_ADD_TYPE,
  GET_SERVICE_ADD_MANUFACTURERS,
  MUTATION_CREATE_SERVICE_ADD_MANUFACTURER,
  MUTATION_UPDATE_SERVICE_ADD_MANUFACTURER,
  MUTATION_DELETE_SERVICE_ADD_MANUFACTURER,
  GET_SERVICE_ADD_BRANDS,
  MUTATION_CREATE_SERVICE_ADD_BRAND,
  MUTATION_UPDATE_SERVICE_ADD_BRAND,
  MUTATION_DELETE_SERVICE_ADD_BRAND,
  GET_SERVICE_ADD_GROUPS,
  MUTATION_CREATE_SERVICE_ADD_GROUP,
  MUTATION_UPDATE_SERVICE_ADD_GROUP,
  MUTATION_DELETE_SERVICE_ADD_GROUP,
  GET_SERVICE_ADDS,
  MUTATION_CREATE_SERVICE_ADD,
  MUTATION_UPDATE_SERVICE_ADD,
  MUTATION_DELETE_SERVICE_ADD,
  GET_SERVICE_INDUSTRIES,
  MUTATION_CREATE_SERVICE_INDUSTRY,
  MUTATION_UPDATE_SERVICE_INDUSTRY,
  MUTATION_DELETE_SERVICE_INDUSTRY,
  MUTATION_DELETE_SERVICE_STANDARD,
  MUTATION_CREATE_SERVICE_STANDARD,
  GET_ELEMENT_MOD_TYPES,
  GET_ELEMENT_MODS,
  MUTATION_CREATE_ELEMENT_MOD_TYPE,
  MUTATION_UPDATE_ELEMENT_MOD_TYPE,
  MUTATION_DELETE_ELEMENT_MOD_TYPE,
  MUTATION_CREATE_ELEMENT_MOD,
  MUTATION_UPDATE_ELEMENT_MOD,
  MUTATION_DELETE_ELEMENT_MOD,
  MUTATION_CREATE_FIXING_GROUP,
  MUTATION_UPDATE_FIXING_GROUP,
  MUTATION_DELETE_FIXING_GROUP,
  GET_FIXING_GROUPS,
  MUTATION_CREATE_FIXING_MATCH,
  MUTATION_UPDATE_FIXING_MATCH,
  GET_FIXING_MATCHLIST,
  MUTATION_DELETE_FIXING_MATCH,
  GET_SYSTEM_NOTE_TYPES,
  GET_SYSTEM_NOTES,
  GET_SYSTEM_NOTES_MATCHLIST,
  MUTATION_CREATE_SYSTEM_NOTE_TYPE,
  MUTATION_UPDATE_SYSTEM_NOTE_TYPE,
  MUTATION_DELETE_SYSTEM_NOTE_TYPE,
  MUTATION_CREATE_SYSTEM_NOTE,
  MUTATION_UPDATE_SYSTEM_NOTE,
  MUTATION_DELETE_SYSTEM_NOTE,
  MUTATION_CREATE_SYSTEM_NOTE_MATCH,
  MUTATION_UPDATE_SYSTEM_NOTE_MATCH,
  MUTATION_DELETE_SYSTEM_NOTE_MATCH,
  GET_QUALITY_CERTIFICATES,
  MUTATION_CREATE_QUALITY_CERTIFICATE,
  MUTATION_UPDATE_QUALITY_CERTIFICATE,
  MUTATION_DELETE_QUALITY_CERTIFICATE
} from './queries'

export const getQueryFor = (
  tableName: string
): {
  create: DocumentNode
  update: DocumentNode
  refetch: DocumentNode
  delete: DocumentNode
  dataKey: string | null
} => {
  switch (tableName) {
    case 'Element':
      return {
        create: MUTATION_CREATE_ELEMENT,
        update: MUTATION_UPDATE_ELEMENT,
        refetch: GET_ELEMENTS,
        delete: MUTATION_DELETE_ELEMENT,
        dataKey: 'input'
      }
    case 'Product':
      return {
        create: MUTATION_CREATE_PRODUCT,
        update: MUTATION_UPDATE_PRODUCT,
        refetch: GET_PRODUCTS,
        delete: MUTATION_DELETE_PRODUCT,
        dataKey: 'input'
      }
    case 'Report':
      return {
        create: MUTATION_CREATE_REPORT,
        update: MUTATION_UPDATE_REPORT,
        refetch: GET_REPORTS,
        delete: MUTATION_DELETE_REPORT,
        dataKey: 'input'
      }
    case 'Service':
      return {
        create: MUTATION_CREATE_SERVICE,
        update: MUTATION_UPDATE_SERVICE,
        refetch: GET_SERVICES,
        delete: MUTATION_DELETE_SERVICE,
        dataKey: 'input'
      }
    case 'ElementType':
      return {
        create: MUTATION_CREATE_ELEMENT_TYPE,
        update: MUTATION_UPDATE_ELEMENT_TYPE,
        refetch: GET_ELEMENT_TYPES,
        delete: MUTATION_DELETE_ELEMENT_TYPE,
        dataKey: 'element_orientation'
      }
    case 'ElementMaterial':
      return {
        create: MUTATION_CREATE_ELEMENT_MATERIAL,
        update: MUTATION_UPDATE_ELEMENT_MATERIAL,
        refetch: GET_ELEMENT_MATERIALS,
        delete: MUTATION_DELETE_ELEMENT_MATERIAL,
        dataKey: null
      }
    case 'ElementMaterialConf':
      return {
        create: MUTATION_CREATE_ELEMENT_MATERIAL_CONF,
        update: MUTATION_UPDATE_ELEMENT_MATERIAL_CONF,
        refetch: GET_ELEMENT_MATERIAL_CONF,
        delete: MUTATION_DELETE_ELEMENT_MATERIAL_CONF,
        dataKey: 'input'
      }
    case 'ElementOrientation':
      return {
        create: MUTATION_CREATE_ELEMENT_ORIENTATION,
        update: MUTATION_UPDATE_ELEMENT_ORIENTATION,
        refetch: GET_ELEMENT_ORIENTATIONS,
        delete: MUTATION_DELETE_ELEMENT_ORIENTATION,
        dataKey: null
      }
    case 'ElementModType':
      return {
        create: MUTATION_CREATE_ELEMENT_MOD_TYPE,
        update: MUTATION_UPDATE_ELEMENT_MOD_TYPE,
        refetch: GET_ELEMENT_MOD_TYPES,
        delete: MUTATION_DELETE_ELEMENT_MOD_TYPE,
        dataKey: null
      }
    case 'ElementMod':
      return {
        create: MUTATION_CREATE_ELEMENT_MOD,
        update: MUTATION_UPDATE_ELEMENT_MOD,
        refetch: GET_ELEMENT_MODS,
        delete: MUTATION_DELETE_ELEMENT_MOD,
        dataKey: 'input'
      }
    case 'ProductInstallationType':
      return {
        create: MUTATION_CREATE_PRODUCT_INSTALLATION_TYPE,
        update: MUTATION_UPDATE_PRODUCT_INSTALLATION_TYPE,
        refetch: GET_PRODUCT_INSTALLATION_TYPES,
        delete: MUTATION_DELETE_PRODUCT_INSTALLATION_TYPE,
        dataKey: null
      }
    case 'ProductType':
      return {
        create: MUTATION_CREATE_PRODUCT_TYPE,
        update: MUTATION_UPDATE_PRODUCT_TYPE,
        refetch: GET_PRODUCT_TYPES,
        delete: MUTATION_DELETE_PRODUCT_TYPE,
        dataKey: null
      }
    case 'ProductCategory':
      return {
        create: MUTATION_CREATE_PRODUCT_CATEGORY,
        update: MUTATION_UPDATE_PRODUCT_CATEGORY,
        refetch: GET_PRODUCT_CATEGORIES,
        delete: MUTATION_DELETE_PRODUCT_CATEGORY,
        dataKey: null
      }
    case 'ProductSubCategory':
      return {
        create: MUTATION_CREATE_PRODUCT_SUB_CATEGORY,
        update: MUTATION_UPDATE_PRODUCT_SUB_CATEGORY,
        refetch: GET_PRODUCT_SUB_CATEGORIES,
        delete: MUTATION_DELETE_PRODUCT_SUB_CATEGORY,
        dataKey: 'input'
      }
    case 'ProductManufacturer':
      return {
        create: MUTATION_CREATE_PRODUCT_MANUFACTURER,
        update: MUTATION_UPDATE_PRODUCT_MANUFACTURER,
        refetch: GET_PRODUCT_MANUFACTURERS,
        delete: MUTATION_DELETE_PRODUCT_MANUFACTURER,
        dataKey: null
      }
    case 'ProductBrand':
      return {
        create: MUTATION_CREATE_PRODUCT_BRAND,
        update: MUTATION_UPDATE_PRODUCT_BRAND,
        refetch: GET_PRODUCT_BRANDS,
        delete: MUTATION_DELETE_PRODUCT_BRAND,
        dataKey: null
      }
    case 'ProductIndustry':
      return {
        create: MUTATION_CREATE_PRODUCT_INDUSTRY,
        update: MUTATION_UPDATE_PRODUCT_INDUSTRY,
        refetch: GET_PRODUCT_INDUSTRIES,
        delete: MUTATION_DELETE_PRODUCT_INDUSTRY,
        dataKey: 'input'
      }
    case 'ProductInstructionList':
      return {
        create: MUTATION_CREATE_PRODUCT_INSTRUCTION_LIST,
        update: MUTATION_UPDATE_PRODUCT_INSTRUCTION_LIST,
        refetch: GET_PRODUCT_INSTRUCTION_LIST,
        delete: MUTATION_DELETE_PRODUCT_PRODUCT_INSTRUCTION_LIST,
        dataKey: 'input'
      }
    case 'ProductMatchingList':
      return {
        create: MUTATION_CREATE_PRODUCT_MATCHING_LIST,
        update: MUTATION_UPDATE_PRODUCT_MATCHING_LIST,
        refetch: GET_PRODUCT_MATCHING_LIST,
        delete: MUTATION_DELETE_PRODUCT_MATCHING_LIST,
        dataKey: null
      }
    case 'ProductAccessoryMatch':
      return {
        create: MUTATION_CREATE_PRODUCT_ACCESSORY_MATCH,
        update: MUTATION_UPDATE_PRODUCT_ACCESSORY_MATCH,
        refetch: GET_PRODUCT_ACCESSORY_MATCH,
        delete: MUTATION_DELETE_PRODUCT_ACCESSORY_MATCH,
        dataKey: null
      }
    case 'ReportType':
      return {
        create: MUTATION_CREATE_REPORT_TYPE,
        update: MUTATION_UPDATE_REPORT_TYPE,
        refetch: GET_REPORT_TYPES,
        delete: MUTATION_DELETE_REPORT_TYPE,
        dataKey: null
      }
    case 'ReportPublishing':
      return {
        create: MUTATION_CREATE_REPORT_PUBLISHING,
        update: MUTATION_UPDATE_REPORT_PUBLISHING,
        refetch: GET_REPORT_PUBLISHINGS,
        delete: MUTATION_DELETE_REPORT_PUBLISHING,
        dataKey: null
      }
    case 'ReportStatus':
      return {
        create: MUTATION_CREATE_REPORT_STATUS,
        update: MUTATION_UPDATE_REPORT_STATUS,
        refetch: GET_REPORT_STATUSES,
        delete: MUTATION_DELETE_REPORT_STATUS,
        dataKey: null
      }
    case 'ReportStandardList':
      return {
        create: MUTATION_CREATE_REPORT_STANDARD_LIST,
        update: MUTATION_UPDATE_REPORT_STANDARD_LIST,
        refetch: GET_REPORT_STANDARD_LIST,
        delete: MUTATION_DELETE_REPORT_STANDARD_LIST,
        dataKey: null
      }
    case 'ReportFacility':
      return {
        create: MUTATION_CREATE_REPORT_FACILITY,
        update: MUTATION_UPDATE_REPORT_FACILITY,
        refetch: GET_REPORT_FACILITIES,
        delete: MUTATION_DELETE_REPORT_FACILITY,
        dataKey: null
      }
    case 'ServiceType':
      return {
        create: MUTATION_CREATE_SERVICE_TYPES,
        update: MUTATION_UPDATE_SERVICE_TYPES,
        refetch: GET_SERVICE_TYPES,
        delete: MUTATION_DELETE_SERVICE_TYPES,
        dataKey: null
      }
    case 'ServiceCategory':
      return {
        create: MUTATION_CREATE_SERVICE_CATEGORY,
        update: MUTATION_UPDATE_SERVICE_CATEGORY,
        refetch: GET_SERVICE_CATEGORIES,
        delete: MUTATION_DELETE_SERVICE_CATEGORY,
        dataKey: 'input'
      }
    case 'ServiceSubCategory':
      return {
        create: MUTATION_CREATE_SERVICE_SUB_CATEGORY,
        update: MUTATION_UPDATE_SERVICE_SUB_CATEGORY,
        refetch: GET_SERVICE_SUB_CATEGORIES,
        delete: MUTATION_DELETE_SERVICE_SUB_CATEGORY,
        dataKey: 'input'
      }
    case 'ServiceMaterial':
      return {
        create: MUTATION_CREATE_SERVICE_MATERIALS,
        update: MUTATION_UPDATE_SERVICE_MATERIALS,
        refetch: GET_SERVICE_MATERIALS,
        delete: MUTATION_DELETE_SERVICE_MATERIALS,
        dataKey: null
      }
    case 'ServiceManufacturer':
      return {
        create: MUTATION_CREATE_SERVICE_MANUFACTURERS,
        update: MUTATION_UPDATE_SERVICE_MANUFACTURERS,
        refetch: GET_SERVICE_MANUFACTURERS,
        delete: MUTATION_DELETE_SERVICE_MANUFACTURERS,
        dataKey: null
      }
    case 'ServiceBrand':
      return {
        create: MUTATION_CREATE_SERVICE_BRANDS,
        update: MUTATION_UPDATE_SERVICE_BRANDS,
        refetch: GET_SERVICE_BRANDS,
        delete: MUTATION_DELETE_SERVICE_BRANDS,
        dataKey: null
      }
    case 'ServiceIndustry':
      return {
        create: MUTATION_CREATE_SERVICE_INDUSTRY,
        update: MUTATION_UPDATE_SERVICE_INDUSTRY,
        refetch: GET_SERVICE_INDUSTRIES,
        delete: MUTATION_DELETE_SERVICE_INDUSTRY,
        dataKey: 'input'
      }
    case 'ServiceStandard':
      return {
        create: MUTATION_CREATE_SERVICE_STANDARD,
        update: MUTATION_UPDATE_SERVICE_STANDARD,
        refetch: GET_SERVICE_STANDARDS,
        delete: MUTATION_DELETE_SERVICE_STANDARD,
        dataKey: null
      }
    case 'ServiceStandardMatch':
      return {
        create: MUTATION_CREATE_SERVICE_STANDARD_MATCH,
        update: MUTATION_UPDATE_SERVICE_STANDARD_MATCH,
        refetch: GET_SERVICE_STANDARD_MATCH,
        delete: MUTATION_DELETE_SERVICE_STANDARD_MATCH,
        dataKey: 'input'
      }
    case 'ServiceAddType':
      return {
        create: MUTATION_CREATE_SERVICE_ADD_TYPE,
        update: MUTATION_UPDATE_SERVICE_ADD_TYPE,
        refetch: GET_SERVICE_ADD_TYPES,
        delete: MUTATION_DELETE_SERVICE_ADD_TYPE,
        dataKey: null
      }
    case 'ServiceAddManufacturer':
      return {
        create: MUTATION_CREATE_SERVICE_ADD_MANUFACTURER,
        update: MUTATION_UPDATE_SERVICE_ADD_MANUFACTURER,
        refetch: GET_SERVICE_ADD_MANUFACTURERS,
        delete: MUTATION_DELETE_SERVICE_ADD_MANUFACTURER,
        dataKey: null
      }
    case 'ServiceAddBrand':
      return {
        create: MUTATION_CREATE_SERVICE_ADD_BRAND,
        update: MUTATION_UPDATE_SERVICE_ADD_BRAND,
        refetch: GET_SERVICE_ADD_BRANDS,
        delete: MUTATION_DELETE_SERVICE_ADD_BRAND,
        dataKey: null
      }
    case 'ServiceAddGroup':
      return {
        create: MUTATION_CREATE_SERVICE_ADD_GROUP,
        update: MUTATION_UPDATE_SERVICE_ADD_GROUP,
        refetch: GET_SERVICE_ADD_GROUPS,
        delete: MUTATION_DELETE_SERVICE_ADD_GROUP,
        dataKey: null
      }
    case 'ServiceAdd':
      return {
        create: MUTATION_CREATE_SERVICE_ADD,
        update: MUTATION_UPDATE_SERVICE_ADD,
        refetch: GET_SERVICE_ADDS,
        delete: MUTATION_DELETE_SERVICE_ADD,
        dataKey: 'input'
      }
    case 'FittingType':
      return {
        create: MUTATION_CREATE_FITTING_TYPE,
        update: MUTATION_UPDATE_FITTING_TYPE,
        refetch: GET_FITTING_TYPES,
        delete: MUTATION_DELETE_FITTING_TYPE,
        dataKey: null
      }
    case 'FixingCategory':
      return {
        create: MUTATION_CREATE_FIXING_CATEGORIES,
        update: MUTATION_UPDATE_FIXING_CATEGORIES,
        refetch: GET_FIXING_CATEGORIES,
        delete: MUTATION_DELETE_FIXING_CATEGORIES,
        dataKey: null
      }
    case 'FixingTested':
      return {
        create: MUTATION_CREATE_FIXING_TESTED,
        update: MUTATION_UPDATE_FIXING_TESTED,
        refetch: GET_FIXING_TESTED,
        delete: MUTATION_DELETE_FIXING_TESTED,
        dataKey: null
      }
    case 'FixingGroup':
      return {
        create: MUTATION_CREATE_FIXING_GROUP,
        update: MUTATION_UPDATE_FIXING_GROUP,
        refetch: GET_FIXING_GROUPS,
        delete: MUTATION_DELETE_FIXING_GROUP,
        dataKey: null
      }
    case 'FixingMatch':
      return {
        create: MUTATION_CREATE_FIXING_MATCH,
        update: MUTATION_UPDATE_FIXING_MATCH,
        refetch: GET_FIXING_MATCHLIST,
        delete: MUTATION_DELETE_FIXING_MATCH,
        dataKey: 'input'
      }
    case 'SealingMethod':
      return {
        create: MUTATION_CREATE_SEALING_METHODS,
        update: MUTATION_UPDATE_SEALING_METHODS,
        refetch: GET_SEALING_METHODS,
        delete: MUTATION_DELETE_SEALING_METHODS,
        dataKey: null
      }
    case 'ServiceConfiguration':
      return {
        create: MUTATION_CREATE_SERVICE_CONFIGURATION,
        update: MUTATION_UPDATE_SERVICE_CONFIGURATION,
        refetch: GET_SERVICE_CONFIGURATIONS,
        delete: MUTATION_DELETE_SERVICE_CONFIGURATION,
        dataKey: null
      }
    case 'Application':
      return {
        create: MUTATION_CREATE_APPLICATION,
        update: MUTATION_UPDATE_APPLICATION,
        refetch: GET_APPLICATIONS,
        delete: MUTATION_DELETE_APPLICATION,
        dataKey: null
      }
    case 'DocumentType':
      return {
        create: MUTATION_CREATE_DOCUMENT_TYPE,
        update: MUTATION_UPDATE_DOCUMENT_TYPE,
        refetch: GET_DOCUMENT_TYPES,
        delete: MUTATION_DELETE_DOCUMENT_TYPE,
        dataKey: null
      }
    case 'Inquiry':
      return {
        create: MUTATION_CREATE_DOCUMENT_TYPE,
        update: MUTATION_UPDATE_DOCUMENT_TYPE,
        refetch: GET_INQUIRIES,
        delete: MUTATION_DELETE_DOCUMENT_TYPE,
        dataKey: null
      }
    case 'IndustryCategory':
      return {
        create: MUTATION_CREATE_INDUSTRY_CATEGORY,
        update: MUTATION_UPDATE_INDUSTRY_CATEGORY,
        refetch: GET_INDUSTRY_CATEGORIES,
        delete: MUTATION_DELETE_INDUSTRY_CATEGORY,
        dataKey: null
      }
    case 'Unit':
      return {
        create: MUTATION_CREATE_UNITS,
        update: MUTATION_UPDATE_UNITS,
        refetch: GET_UNITS,
        delete: MUTATION_DELETE_UNITS,
        dataKey: null
      }
    case 'DocumentVersion':
      return {
        create: MUTATION_CREATE_DOCUMENT_VERSION,
        update: MUTATION_UPDATE_DOCUMENT_VERSION,
        refetch: GET_DOCUMENT_VERSIONS,
        delete: MUTATION_DELETE_DOCUMENT_VERSION,
        dataKey: null
      }
    case 'DimensionType':
      return {
        create: MUTATION_CREATE_DIMENSION_TYPE,
        update: MUTATION_UPDATE_DIMENSION_TYPE,
        refetch: GET_DIMENSION_TYPES,
        delete: MUTATION_DELETE_DIMENSION_TYPE,
        dataKey: null
      }
    case 'FRLStandard':
      return {
        create: MUTATION_CREATE_FRL_STANDARD,
        update: MUTATION_UPDATE_FRL_STANDARD,
        refetch: GET_FRL_STANDARDS,
        delete: MUTATION_DELETE_FRL_STANDARD,
        dataKey: null
      }
    case 'FAQ':
      return {
        create: MUTATION_CREATE_FAQ,
        update: MUTATION_UPDATE_FAQ,
        refetch: GET_FAQS,
        delete: MUTATION_DELETE_FAQ,
        dataKey: null
      }
    case 'ComponentProduct':
      return {
        create: MUTATION_CREATE_COMPONENT_PRODUCT,
        update: MUTATION_UPDATE_COMPONENT_PRODUCT,
        refetch: GET_COMPONENT_PRODUCTS,
        delete: MUTATION_DELETE_COMPONENT_PRODUCT,
        dataKey: 'input'
      }
    case 'System':
      return {
        create: MUTATION_CREATE_SYSTEM,
        update: MUTATION_UPDATE_SYSTEM,
        refetch: GET_SYSTEM,
        delete: MUTATION_DELETE_SYSTEM,
        dataKey: 'input'
      }
    case 'SystemNoteType':
      return {
        create: MUTATION_CREATE_SYSTEM_NOTE_TYPE,
        update: MUTATION_UPDATE_SYSTEM_NOTE_TYPE,
        refetch: GET_SYSTEM_NOTE_TYPES,
        delete: MUTATION_DELETE_SYSTEM_NOTE_TYPE,
        dataKey: null
      }
    case 'SystemNote':
      return {
        create: MUTATION_CREATE_SYSTEM_NOTE,
        update: MUTATION_UPDATE_SYSTEM_NOTE,
        refetch: GET_SYSTEM_NOTES,
        delete: MUTATION_DELETE_SYSTEM_NOTE,
        dataKey: 'input'
      }
    case 'SystemNoteMatch':
      return {
        create: MUTATION_CREATE_SYSTEM_NOTE_MATCH,
        update: MUTATION_UPDATE_SYSTEM_NOTE_MATCH,
        refetch: GET_SYSTEM_NOTES_MATCHLIST,
        delete: MUTATION_DELETE_SYSTEM_NOTE_MATCH,
        dataKey: 'input'
      }
    case 'HomePageTile':
      return {
        create: MUTATION_CREATE_HOMEPAGE_TILE,
        update: MUTATION_UPDATE_HOMEPAGE_TILE,
        refetch: GET_HOMEPAGE_TILES,
        delete: MUTATION_DELETE_HOMEPAGE_TILE,
        dataKey: 'input'
      }
    case 'QualityCertificate':
      return {
        create: MUTATION_CREATE_QUALITY_CERTIFICATE,
        update: MUTATION_UPDATE_QUALITY_CERTIFICATE,
        refetch: GET_QUALITY_CERTIFICATES,
        delete: MUTATION_DELETE_QUALITY_CERTIFICATE,
        dataKey: 'input'
      }
    case 'FMPProject':
      return {
        create: MUTATION_CREATE_HOMEPAGE_TILE,
        update: MUTATION_UPDATE_HOMEPAGE_TILE,
        refetch: GET_FMP_PROJECTS,
        delete: MUTATION_DELETE_HOMEPAGE_TILE,
        dataKey: null
      }
    case 'SnapUser':
      return {
        create: MUTATION_CREATE_HOMEPAGE_TILE,
        update: MUTATION_UPDATE_HOMEPAGE_TILE,
        refetch: GET_SNAP_USERS,
        delete: MUTATION_DELETE_HOMEPAGE_TILE,
        dataKey: 'null'
      }
    default:
      return {
        create: GET_SNAP_USERS,
        update: GET_SNAP_USERS,
        refetch: GET_SNAP_USERS,
        delete: GET_SNAP_USERS,
        dataKey: 'input'
      }
  }
}
